<template>
    <div>
        <v-card flat>
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>
                        Print Canteen Fee Receipt
                    </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-btn v-if="receipt_data != null" class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            <span v-if="receipt_data != null">
                <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                    <v-radio label="Both" value="both" color="#0f2027"></v-radio>
                    <v-radio label="Office Copy" value="office" color="#0f2027"></v-radio>
                    <v-radio label="Student Copy" value="student" color="#0f2027"></v-radio>
                </v-radio-group>
                <v-row dense>
                    <v-col cols="12" sm="6" md="6" v-if="radios == 'office'">
                        <v-card>
                            <v-simple-table dense class="elevation-1 table-container">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th colspan="3">
                                                <center><strong>Canteen Fee Receipt</strong></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th v-if="org_basic_data.trust_logo">
                                                <center><img :src="org_basic_data.trust_logo" width="50%" alt="logo" /></center>
                                            </th>
                                            <td>
                                                <center>
                                                    <tr v-if="org_basic_data.trust_name">
                                                        <strong>{{org_basic_data.trust_name}}</strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.school_name">
                                                        <strong>{{org_basic_data.school_name}} </strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.address">
                                                        {{org_basic_data.address}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.phone">
                                                        Phone : {{org_basic_data.phone}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.email">
                                                        Email : {{org_basic_data.email}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.website">
                                                        Website : {{org_basic_data.website}}
                                                    </tr>
                                                </center>
                                            </td>
                                            <th v-if="org_basic_data.school_logo">
                                                <center><img :src="org_basic_data.school_logo" width="50%" alt="logo" /></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <center><strong>Student Details</strong></center>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">PRN No. : {{receipt_data.registration_number}}</td>
                                            <td colspan="">Standard : {{receipt_data.standard}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">Student Name : {{receipt_data.name}}</td>
                                            <td colspan="">Date : {{receipt_data.receipt_date}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">Receipt No. : {{receipt_data.receipt_no}} (Office Copy)</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colspan="2"><strong>Installment</strong></td>
                                            <td><strong> Fee Amount (Rs.)</strong></td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                {{receipt_data.installment}}
                                            </td>
                                            <td>{{receipt_data.amount}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Total Amount :</strong> Rs. {{receipt_data.amount}}.00</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Amount In Words :</strong> {{ receipt_data.amount_in_words }} </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Mode:</strong> {{ receipt_data.paymentmode }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Details:</strong> {{ receipt_data.remark }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-right">
                                                <v-col cols="12" sm="12" md="12"> </v-col>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-right">
                                                <strong>Authorized Signature</strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="6" md="6" v-if="radios == 'student'">
                        <v-card>
                            <v-simple-table dense class="elevation-1 table-container">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th colspan="3">
                                                <center><strong>Canteen Fee Receipt</strong></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th v-if="org_basic_data.trust_logo">
                                                <center><img :src="org_basic_data.trust_logo" width="50%" alt="logo" /></center>
                                            </th>
                                            <td>
                                                <center>
                                                    <tr v-if="org_basic_data.trust_name">
                                                        <strong>{{org_basic_data.trust_name}}</strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.school_name">
                                                        <strong>{{org_basic_data.school_name}} </strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.address">
                                                        {{org_basic_data.address}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.phone">
                                                        Phone : {{org_basic_data.phone}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.email">
                                                        Email : {{org_basic_data.email}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.website">
                                                        Website : {{org_basic_data.website}}
                                                    </tr>
                                                </center>
                                            </td>
                                            <th v-if="org_basic_data.school_logo">
                                                <center><img :src="org_basic_data.school_logo" width="50%" alt="logo" /></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <center><strong>Student Details</strong></center>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">PRN No. : {{receipt_data.registration_number}}</td>
                                            <td colspan="">Standard : {{receipt_data.standard}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">Student Name : {{receipt_data.name}}</td>
                                            <td colspan="">Date : {{receipt_data.receipt_date}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">Receipt No. : {{receipt_data.receipt_no}} (Student Copy)</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colspan="2"><strong>Installment</strong></td>
                                            <td><strong> Fee Amount (Rs.)</strong></td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                {{receipt_data.installment}}
                                            </td>
                                            <td>{{receipt_data.amount}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Total Amount :</strong> Rs. {{receipt_data.amount}}.00</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Amount In Words :</strong>  {{ receipt_data.amount_in_words }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Mode:</strong> {{ receipt_data.paymentmode }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Details:</strong> {{ receipt_data.remark }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-right">
                                                <v-col cols="12" sm="12" md="12"> </v-col>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-right">
                                                <strong>Authorized Signature</strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row dense v-if="radios == 'both'">
                    <v-col cols="12" sm="6" md="6">
                        <v-card>
                            <v-simple-table dense class="elevation-1 table-container">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th colspan="3">
                                                <center><strong>Canteen Fee Receipt</strong></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th v-if="org_basic_data.trust_logo">
                                                <center><img :src="org_basic_data.trust_logo" width="50%" alt="logo" /></center>
                                            </th>
                                            <td>
                                                <center>
                                                    <tr v-if="org_basic_data.trust_name">
                                                        <strong>{{org_basic_data.trust_name}}</strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.school_name">
                                                        <strong>{{org_basic_data.school_name}} </strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.address">
                                                        {{org_basic_data.address}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.phone">
                                                        Phone : {{org_basic_data.phone}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.email">
                                                        Email : {{org_basic_data.email}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.website">
                                                        Website : {{org_basic_data.website}}
                                                    </tr>
                                                </center>
                                            </td>
                                            <th v-if="org_basic_data.school_logo">
                                                <center><img :src="org_basic_data.school_logo" width="50%" alt="logo" /></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <center><strong>Student Details</strong></center>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">PRN No. : {{receipt_data.registration_number}}</td>
                                            <td colspan="">Standard : {{receipt_data.standard}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">Student Name : {{receipt_data.name}}</td>
                                            <td colspan="">Date : {{receipt_data.receipt_date}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">Receipt No. : {{receipt_data.receipt_no}} (Office Copy)</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colspan="2"><strong>Installment</strong></td>
                                            <td><strong> Fee Amount (Rs.)</strong></td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                {{receipt_data.installment}}
                                            </td>
                                            <td>{{receipt_data.amount}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Total Amount :</strong> Rs. {{receipt_data.amount}}.00</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Amount In Words :</strong> {{ receipt_data.amount_in_words }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Mode:</strong> {{ receipt_data.paymentmode }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Details:</strong> {{ receipt_data.remark }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-right">
                                                <v-col cols="12" sm="12" md="12"> </v-col>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-right">
                                                <strong>Authorized Signature</strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-card>
                            <v-simple-table dense class="elevation-1 table-container">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th colspan="3">
                                                <center><strong>Canteen Fee Receipt</strong></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th v-if="org_basic_data.trust_logo">
                                                <center><img :src="org_basic_data.trust_logo" width="50%" alt="logo" /></center>
                                            </th>
                                            <td>
                                                <center>
                                                    <tr v-if="org_basic_data.trust_name">
                                                        <strong>{{org_basic_data.trust_name}}</strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.school_name">
                                                        <strong>{{org_basic_data.school_name}} </strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.address">
                                                        {{org_basic_data.address}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.phone">
                                                        Phone : {{org_basic_data.phone}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.email">
                                                        Email : {{org_basic_data.email}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.website">
                                                        Website : {{org_basic_data.website}}
                                                    </tr>
                                                </center>
                                            </td>
                                            <th v-if="org_basic_data.school_logo">
                                                <center><img :src="org_basic_data.school_logo" width="50%" alt="logo" /></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <center><strong>Student Details</strong></center>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">PRN No. : {{receipt_data.registration_number}}</td>
                                            <td colspan="">Standard : {{receipt_data.standard}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">Student Name : {{receipt_data.name}}</td>
                                            <td colspan="">Date : {{receipt_data.receipt_date}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">Receipt No. : {{receipt_data.receipt_no}} (Student Copy)</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colspan="2"><strong>Installment</strong></td>
                                            <td><strong> Fee Amount (Rs.)</strong></td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                {{receipt_data.installment}}
                                            </td>
                                            <td>{{receipt_data.amount}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Total Amount :</strong> Rs. {{receipt_data.amount}}.00</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Amount In Words :</strong>  {{ receipt_data.amount_in_words }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Mode:</strong> {{ receipt_data.paymentmode }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Details:</strong> {{ receipt_data.remark }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-right">
                                                <v-col cols="12" sm="12" md="12"> </v-col>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-right">
                                                <strong>Authorized Signature</strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                </v-row>
            </span>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                overlay: false,
                receipt_data: null,
                radios: null,
                receipt_no: null,
                registration_no: null,
                ay: null,
                radios: null,
                org_basic_data: [],
            };
        },
        watch: {
            receipt_no() {
                this.getData();
            },

            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        created() {
            this.receipt_no = JSON.parse(this.$session.get("receipt_no"));
            this.ay = JSON.parse(this.$session.get("ay"));
        },
        mounted() {
            this.getData();
        },
        methods: {
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            convert(number) {
                var converter = require("number-to-words");
                const string = converter.toWords(number);
                const string1 = string.charAt(0).toUpperCase() + string.slice(1);
                return string1;
            },
            getData() {
                this.overlay = true;
                this.receipt_data = null;
                const formData = {
                    receipt_no: this.receipt_no,
                    ay: this.ay,
                };
                axios
                    .post("/Canteen/getReceipt", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.receipt_data = res.data.receipt_data;
                            this.org_basic_data = res.data.org_basic_data;
                            this.overlay = false;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.overlay = false;
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        //close loader
                        this.overlay = false;
                    });
            },
        },
    };
</script>
<style scoped>
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }

    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        img {
            width: 100% !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        body,
        tr,
        th,
        td {
            font-size: xx-large !important;
            font-weight: bold !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        @page {
            margin-top: none;
            padding-top: none;
            size: 27.5in 18.5in;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin: none;
            padding: 1rem !important;
            font-size: xx-large !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
    .table-container {
        overflow-x: hidden;
        overflow: hidden;
    }
</style>
